import { IAppState } from '../../common/state';
import { ENewbuildingLayoutFetchStatus } from '../../types/residentialComplexLayouts/layoutWithOffers/layoutWithOffers';

export const residentialComplexLayoutOffersRequestStatusSelector = (
  state: IAppState,
): ENewbuildingLayoutFetchStatus => {
  return state.newbuildingLayoutOffers.fetchStatus;
};
